import React from 'react';
import { useSelector } from 'react-redux';
import { selectBehaviorFromBootstrap } from 'store/slice/bootstrap';

const SessionPackage = React.lazy(() => import('component/common/SessionPackageInitialization/SessionPackage/SessionPackage'));

export const SessionPackageInitialization: React.FC = () => {
    const behavior = useSelector(selectBehaviorFromBootstrap);
    const isSessionPackageEnabled = behavior.common.userSessionManagement?.isEnabled;

    return <React.Suspense fallback={null}>{isSessionPackageEnabled ? <SessionPackage /> : null}</React.Suspense>;
};
SessionPackageInitialization.displayName = 'SessionPackageInitialization';
